import { render, staticRenderFns } from "./errorPages.vue?vue&type=template&id=1b2aa0be&"
import script from "./errorPages.vue?vue&type=script&lang=js&"
export * from "./errorPages.vue?vue&type=script&lang=js&"
import style0 from "./errorPages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports